module.exports = __webpack_public_path__ + "img/collectiongallery_signet.73d6eaa.webp";